import type {App} from 'vue';
import useFeatures from '@/composables/useFeatures';

export const featureToggles = {
  install: (app: App): void => {
    const {loadFeatureToggles} = useFeatures();
    loadFeatureToggles();
  },
};
